<template>
  <div class="min-h-screen font-sans">
    <header class="py-6 px-4 md:px-8 backdrop-blur-md bg-white bg-opacity-80 sticky top-0 z-10 border-b border-white border-opacity-20">
      <div class="max-w-5xl mx-auto flex justify-between items-center">
        <h1 class="text-2xl font-semibold bg-sunset-gradient bg-clip-text text-transparent">Remote Developer Bingo</h1>
      </div>
    </header>
    <main class="py-8 px-4 md:px-8">
      <div class="max-w-5xl mx-auto">
        <router-view />
      </div>
    </main>
    <!-- No footer -->
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>